import PropertyDetails from './PropertyDetails.component';

export default PropertyDetails;
